var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2929 4.7248C22.0979 3.5293 20.4099 3.3418 18.4179 3.3418H9.55844C7.58994 3.3418 5.90244 3.5293 4.70694 4.7243C3.51194 5.9193 3.33594 7.5953 3.33594 9.5528V18.4118C3.33594 20.4158 3.51194 22.0798 4.70694 23.2753C5.90194 24.4703 7.58994 24.6578 9.59394 24.6578H18.4179C20.4099 24.6578 22.0979 24.4703 23.2929 23.2753C24.4879 22.0803 24.6639 20.4158 24.6639 18.4118V9.5878C24.6639 7.5838 24.4884 5.9083 23.2929 4.7248ZM13.9999 20.8723C13.7546 20.8719 13.5193 20.7743 13.3458 20.6008C13.1722 20.4273 13.0745 20.1922 13.0739 19.9468V14.9198H8.05894C7.54294 14.9198 7.13294 14.4978 7.13294 14.0058C7.13294 13.5133 7.54294 13.0683 8.05844 13.0683H13.0739V8.0523C13.0739 7.5253 13.4839 7.1148 13.9999 7.1148C14.5274 7.1148 14.9259 7.5248 14.9259 8.0523V13.0683H19.9529C20.4689 13.0683 20.8789 13.5133 20.8789 14.0058C20.8789 14.4978 20.4689 14.9198 19.9529 14.9198H14.9259V19.9473C14.9267 20.0691 14.9032 20.1898 14.8569 20.3024C14.8106 20.4151 14.7425 20.5174 14.6563 20.6035C14.5702 20.6896 14.4678 20.7578 14.3551 20.804C14.2425 20.8502 14.1217 20.8731 13.9999 20.8723Z",
    fill: "#1B3E61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupPlusIcon);
export default __webpack_public_path__ + "static/media/group-plus-icon.5639e1443b7cf6845758679e9705f655.svg";
export { ForwardRef as ReactComponent };